import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/react/shallow";
import { queryKeys } from "../lib/queryClient";
import { useAuthStore, fetchUserProfile } from "../stores/useAuthStore";

/**
 * Loads the authenticated user's profile via React Query.
 * Use when you need the latest profile data; it is automatically disabled until auth is ready.
 * Returns the full query object so callers can inspect `data`, `status`, and `refetch`.
 */
export function useUserProfile(options?: { enabled?: boolean }) {
  const { authUser } = useAuthStore(
    useShallow((state) => ({ authUser: state.authUser }))
  );
  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey: authUser
      ? queryKeys.userProfile(authUser.uid)
      : queryKeys.userProfile("missing-user"),
    enabled: enabled && Boolean(authUser),
    queryFn: () => fetchUserProfile(),
  });
}
